module.exports = __webpack_public_path__ + "media/images/companyPage/innovation-4f485fb18cb3dcfd076adcd5a4d28341.svg";